import React from "react";
import ChooseFile from "/src/components/UI/ChooseFile/ChooseFile";
import Field from "/src/components/UI/Field/Field";

const FromDocuments = ({ setFile, file, loadAnim }) => {
    return (
        <div>
            <Field label="Documents" />
            <ChooseFile
                _setFile={setFile}
                currentFile={file}
                accept=".pdf,.doc,.docx,.txt,.png,.jpg,.jpeg"
                loadAnim={loadAnim}
                colorBorder={"inset 0 0 0 1px #dddddd;"}
            />
        </div>
    );
};

export default FromDocuments;
